export const REQUEST_LOGIN_MODES = {
  LOGIN: 'login',
  SIGN_UP: 'signup',
};
